<template>
    <div class="mb-3">

        <base-input
            :label="label"
            placeholder="YYYY/MM/DD"
            :label-classes="labelClasses"
            :value="date"
            :name="name+'-date'"
            :rules="rules"
            :error="error"
            @input="processDate"
            @blur="normalizeDate"
        >
        </base-input>

        <base-input
            placeholder="HH:MM"
            :label-classes="labelClasses"
            :value="time"
            :name="name+'-time'"
            :rules="rules"
            :error="error"
            @input="processTime"
            @blur="normalizeTime"
        >
        </base-input>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {

        props: {

            label: {
                type: String,
            },

            labelClasses: {
                type: String,
                default: "form-control-label"
            },

            value: {
                type: String,
                default: ''
            },

            name: {
                type: String,
                default: ''
            },

            rules: {
                type: [String, Array, Object],
                default: ''
            },

            error: {
                type: String,
            },
        },

        data() {
            return {
                moment,
            }
        },

        computed: {

            date() {
                return this.value
                    ? this.value.split(' ')[0].split('-').join('/')
                    : this.moment().format('YYYY/MM/DD')
            },

            rfcDate() {
                return this.date.split('/').join('-')
            },

            time() {
                return this.value
                    ? this.value.split(' ')[1]
                    : (parseInt(this.moment().format('HH')) + 1) + ''
            },
        },

        created() {
            this.normalizeDate()
            this.normalizeTime()
        },

        watch: {
            value(newValue) {
                if (!newValue) {
                    this.normalizeDate()
                    this.normalizeTime()
                }
            },
        },

        methods: {

            processDate(value) {
                const filtered = value.replace(/[^0-9]/g, '')
                    .replace(/^(\d{4})(\d{2})?/g, '$1/$2')
                    .replace(/^(\d{4})\/(\d{2})(\d{2})?/g, '$1/$2/$3')
                    .substr(0, 10)

                let date = filtered.split('/')
                if (parseInt(date[1]) > 12) {
                    date[1] = 12
                }
                if (parseInt(date[2]) > 31) {
                    date[2] = 31
                }

                this.$emit('input', date.join('-') + ' ' + this.time)
            },

            processTime(value) {
                const filtered = value.replace(/[^0-9]/g, '')
                    .replace(/^(\d{2})(\d{2})?/g, '$1:$2')
                    .substr(0, 5)

                let time = filtered.split(':')
                if (parseInt(time[0]) > 23) {
                    time[0] = 23
                }
                if (parseInt(time[1]) > 59) {
                    time[1] = 59
                }

                this.$emit('input', this.rfcDate + ' ' + time.join(':'))
            },

            normalizeDate() {
                let date = this.date.split('/')

                if (date.length == 0 || (date.length == 1 && date[0] == '')) {
                    return
                }

                // Year.
                while (date[0].length < 4) {
                    if (date[0].length < 3) {
                        date[0] = '0' + date[0]
                    } else {
                        date[0] = '2' + date[0]
                    }
                }

                // Month.
                if (date.length == 1) {
                    date.push('01')
                }
                if (date[1] == '') {
                    date[1] = '01'
                }
                while (date[1].length < 2) {
                    date[1] = '0' + date[1]
                }

                // Day.
                if (date.length == 2) {
                    date.push('01')
                }
                if (date[2] == '') {
                    date[2] = '01'
                }
                while (date[2].length < 2) {
                    date[2] = '0' + date[2]
                }

                this.$emit('input', date.join('-') + ' ' + this.time)
            },

            normalizeTime() {
                let time = this.time.split(':')

                if (time.length == 0 || (time.length == 1 && time[0] == '')) {
                    return
                }

                // Hour.
                if (time[0] == '') {
                    time[0] = '09'
                }
                while (time[0].length < 2) {
                    time[0] = '0' + time[0]
                }

                // Minutes.
                if (time.length == 1) {
                    time.push('00')
                }
                if (time[1] == '') {
                    time[1] = '00'
                }
                while (time[1].length < 2) {
                    time[1] = '0' + time[1]
                }

                this.$emit('input', this.rfcDate + ' ' + time.join(':'))
            }
        }
    }
</script>
